<template>
  <div>
    <xolas-table
      table-ref="insurance-table"

      title="Insurance"
      icon="fa fa-shield-alt"

      hide-org-badge
      :show-search="false"

      :url="'/insurance/site/' + rowData.id"

      :fields="fields">

    </xolas-table>


  </div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'

export default {

mixins: [DateMixins, NumberMixins],

  components: {
    XolasTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatStatus (value, inclText = false) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Completed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'KIV') {
        icon = 'clock'
      }

      if (value === 'Pending Payment') {
        color = 'goldenrod'
        icon = 'credit-card'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Active') {
        color = 'slateblue'
        icon = 'check'
      }

      if (value === 'Terminated') {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return '<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '&nbsp;</i><span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? value : '')) +
        '</span></b>'
    }
  },

  data () {
    return {
      // Per-column min-widths in content ratios so el-table flexes to fill instead
      // of distributing every column equally; sum under the table width (XOL-231).
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id',
          minWidth: '45'
        },
        {
          name: 'policyType',
          title: 'Type',
          sortField: 'policyType',
          minWidth: '145'
        },
        {
          name: 'policyNo',
          title: 'Policy #',
          sortField: 'policyNo',
          minWidth: '110'
        },
        {
          name: 'provider.shortName',
          title: 'Provider',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '95'
        },
        {
          name: 'beneficary.shortName',
          title: 'Beneficiary',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '120'
        },
        {
          name: 'premium',
          title: 'Premium',
          sortField: 'premium',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber,
          minWidth: '90'
        },
        {
          name: 'frequency',
          title: 'Frequency',
          sortField: 'frequency',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '95'
        },
        {
          name: 'coverageStart',
          title: 'Started On',
          sortField: 'coverageStart',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate,
          minWidth: '105'
        },
        {
          name: 'coverageEnd',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate,
          minWidth: '108'
        }
     ]
  }
}
}

</script>
